import { render, staticRenderFns } from "./BorrowerProfile.vue?vue&type=template&id=79ce03fe"
import script from "./BorrowerProfile.vue?vue&type=script&lang=js"
export * from "./BorrowerProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79ce03fe')) {
      api.createRecord('79ce03fe', component.options)
    } else {
      api.reload('79ce03fe', component.options)
    }
    module.hot.accept("./BorrowerProfile.vue?vue&type=template&id=79ce03fe", function () {
      api.rerender('79ce03fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/profile/BorrowerProfile.vue"
export default component.exports